import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonsComponent } from 'app/reporting/components/reusable/radio-buttons/radio-buttons.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HeaderComponent } from 'app/shared/components/header/header.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { PerformanceFactsComponent } from './components/performance-facts/performance-facts.component';
import { PowerForecastComponent } from './components/power-forecast/power-forecast.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ServicesModule } from './services/services.module';
import { LoadFactorComponent } from './components/load-factor/load-factor.component';
import { RootSharedModule } from './root-shared.module';
import { AlarmsPopupComponent } from './components/alarms-popup/alarms-popup.component';
import { ClickedAlarms } from './components/alarms-popup/clicked-alarms';
import { PageNavigationComponent } from './components/page-navigation/page-navigation.component';
import { EfficiencyComponent } from './components/efficiency/efficiency.component';
import { WindNacelleDirectionComponent } from './components/wind-nacelle-direction/wind-nacelle-direction.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ColorLineLegendComponent } from './components/color-line-legend/color-line-legend.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ColorcodeLegendComponent } from './components/header/colorcode-legend/colorcode-legend.component';
import { ParkLegendComponent } from './components/header/colorcode-legend/park-legend/park-legend.component';
import { TurbineLegendComponent } from './components/header/colorcode-legend/turbine-legend/turbine-legend.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { UserBoxComponent } from './components/header/user-box/user-box.component';
import { NotificationComponent } from './components/header/notification/notification.component';
import { SortComponent } from './components/sort/sort.component';
import { AlarmsComponent } from './components/alarms/alarms.component';
import { AlarmsCmsTableComponent } from './components/alarms/alarms-cms-table/alarms-cms-table.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PerformanceMonitoringComponent } from './components/performance-monitoring/performance-monitoring.component';
import { MonitoringWeatherComponent } from './components/monitoring-weather/monitoring-weather.component';
import { ShowAllComponent } from './components/show-all/show-all.component';
import { AlarmsTableComponent } from './components/alarms/alarms-table/alarms-table.component';
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { ExportDataComponent } from './components/export-data/export-data.component';
import { ExportChartComponent } from './components/export-chart/export-chart.component';
import { PowerForecastChartComponent } from './components/power-forecast/components/forecast-chart/power-forecast-chart.component';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { SavePopupComponent } from './components/save-popup/save-popup.component';
import { CardComponent } from './components/card/card.component';
import { CardBodyComponent } from './components/card/card-body/card-body.component';
import { CardHeaderComponent } from './components/card/card-header/card-header.component';
import { PowerCurveComponent } from 'app/analyze/views/windpark-analyze/wpv-v7/provisional-component-folder/power-curve.component';
import { WindDirectionChartComponent } from './components/wind-direction-chart/wind-direction-chart.component';
import { LanguageSwitchComponent } from './components/header/language-switch/language-switch.component';
import {
  LinkingService,
  FeComponentLibraryModule, LibCardModule,
  ThemeModule
} from '@wind-log_library/fe-component-library';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import {LegendGraphComponent} from './components/legend-graph/legend-graph.component';
import {AvailabilityHeatmapComponent} from './components/availability-heatmap/availability-heatmap.component';
import { LoadingAndNoDataTemplateComponent } from './components/loading-and-no-data-template/loading-and-no-data-template.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SmallDeviceAlertComponent } from './components/small-device-alert/small-device-alert.component';
import {ForecastChartComponent} from './components/forecast-chart/forecast-chart.component';
import {MeteoServiceSelectComponent} from './components/meteoservice-select/meteoservice-select.component';
import {TimeRangeSelectorComponent} from './components/time-range-selector/time-range-selector.component';
import {KpiAnalyticsPieChartComponent} from './components/kpi/kpi-analytics-pie-chart/kpi-analytics-pie-chart.component';
import {KpiFilterComponent} from './components/kpi/kpi-filter/kpi-filter.component';
import {KpiTClassBlocksListTableComponent} from './components/kpi/kpi-processes-list-table/kpi-t-class-blocks-list-table/kpi-t-class-blocks-list-table.component';
import {KpiProcessesListTableComponent} from './components/kpi/kpi-processes-list-table/kpi-processes-list-table.component';
import {KpiPlannedEventsListTableComponent} from './components/kpi/kpi-processes-list-table/kpi-planned-events-list-table/kpi-planned-events-list-table.component';
import {KpiPlanningAnalyticsListTableComponent} from './components/kpi/kpi-planning-analytics-list-table/kpi-planning-analytics-list-table.component';
import {KpiPlanningAnalyticsScheduleChartComponent} from './components/kpi/kpi-planning-analytics-schedule-chart/kpi-planning-analytics-schedule-chart.component';
import {KpiPlanningAnalyticsScheduleChartViewComponent} from './components/kpi/kpi-planning-analytics-schedule-chart/kpi-planning-analytics-schedule-chart-view/kpi-planning-analytics-schedule-chart-view.component';
import {KpiProcessAnalyticsScheduleChartComponent} from './components/kpi/kpi-planning-analytics-schedule-chart/kpi-process-analytics-schedule-chart.component';
import {KpiAvailabilityDailyChartComponent} from './components/kpi/kpi-availability-daily-chart/kpi-availability-daily-chart.component';
import {KpiAvailabilityMonthlyChartComponent} from './components/kpi/kpi-availability-monthly-chart/kpi-availability-monthly-chart.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import {
    ProductionGridQualityComponent
} from './components/check-revenues/production-grid-quality/production-grid-quality.component';
import { CustomDateRangeComponent } from './components/custom-date-range/custom-date-range.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import {TclassFilterComponent} from './components/tclass-filter/tclass-filter.component';
import {NavigationComponent} from './components/navigation/navigation.component';
import {HeaderFilterComponent} from './components/header-filter/header-filter.component';
import {CheckBoxComponent} from './components/check-box/check-box.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotificationMessageComponent } from './components/notification-message/notification-message.component';
import { TimeRangeSliderComponent } from './components/time-range-slider/time-range-slider.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatSortModule } from '@angular/material/sort';
import { TimerComponent } from './components/timer/timer.component';
import { AvailabilityHeatmapCanvasComponent } from './components/availability-heatmap-canvas/availability-heatmap-canvas.component';
import { HeaderUserSettingsComponent } from './components/header/header-user-settings/header-user-settings.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { BellSwitchComponent } from './components/header/bell-switch/bell-switch.component';
import { ReleaseNotesComponent } from './components/release-notes/release-notes.component';
import { NotificationClearPopupComponent } from './components/header/notification-clear-popup/notification-clear-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { LogoutMessageComponent } from './components/header/user-box/logout-message/logout-message.component';
import { TimezoneSwitchComponent } from './components/header/timezone-switch/timezone-switch.component';
import { NewApplicationVersionPopupComponent } from './components/new-application-version-popup/new-application-version-popup.component';
import { LoadFactorChartComponent } from './components/load-factor-highchart/load-factor-highchart.component';
import { TachometerComponent } from './components/tachometer/tachometer.component';
import { BaseMapComponent } from './components/base-map/base-map.component';
import { DoughnutStatusChartComponent } from './components/base-map/components/doughnut-status/doughnut-status.component';
import { GeomapMarkerParkComponent } from './components/base-map/components/geomap-marker-park/geomap-marker-park.component';
import { GeomapMarkerStatusComponent } from './components/base-map/components/geomap-marker-status/geomap-marker-status.component';
import { HighchartsChartModule } from "highcharts-angular";
import { PerformanceAnalyzeHighChartComponent } from './components/performance-monitoring/performance-analyze-highchart/performance-analyze-highchart.component';
import { PerformanceAlarmListComponent } from './components/performance-monitoring/performance-alarm-list/performance-alarm-list.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { MatMenuModule } from '@angular/material/menu';
import { CustomTooltipDirective } from './directives/custom-tooltip/custom-tooltip.directive';
import { ProcessDetailsComponent } from 'app/planning/components/process-details/process-details.component';
import { PortalModule } from '@angular/cdk/portal';
import { FixedTimeRangeSelectionModule } from '@wind-log_library/fe-component-library';
import { SiteTechnologyButtonsComponent } from './components/site-technology-buttons/site-technology-buttons.component';

const COMPONENTS: any[] = [
  SiteTechnologyButtonsComponent,
  RadioButtonsComponent,
  HeaderComponent,
  SideNavComponent,
  ParkLegendComponent,
  TurbineLegendComponent,
  PerformanceFactsComponent,
  PowerForecastComponent,
  AlarmsComponent,
  SpinnerComponent,
  LoadFactorComponent,
  AlarmsPopupComponent,
  PageNavigationComponent,
  EfficiencyComponent,
  WindNacelleDirectionComponent,
  ColorLineLegendComponent,
  ConfirmationPopupComponent,
  AlarmsCmsTableComponent,
  ColorcodeLegendComponent,
  UserBoxComponent,
  LogoutMessageComponent,
  NotificationComponent,
  NotificationClearPopupComponent,
  SortComponent,
  PerformanceMonitoringComponent,
  MonitoringWeatherComponent,
  ShowAllComponent,
  AlarmsTableComponent,
  InfoTooltipComponent,
  ExportDataComponent,
  MonthPickerComponent,
  SavePopupComponent,
  CardComponent,
  CardHeaderComponent,
  CardBodyComponent,
  PowerCurveComponent,
  WindDirectionChartComponent,
  LanguageSwitchComponent,
  BellSwitchComponent,
  ReleaseNotesComponent,
  ProgressBarComponent,
  LegendGraphComponent,
  AvailabilityHeatmapComponent,
  LoadingAndNoDataTemplateComponent,
  SmallDeviceAlertComponent,
  ForecastChartComponent,
  MeteoServiceSelectComponent,
  TimeRangeSelectorComponent,
  SmallDeviceAlertComponent,
  KpiAnalyticsPieChartComponent,
  KpiFilterComponent,
  KpiProcessesListTableComponent,
  KpiPlannedEventsListTableComponent,
  KpiTClassBlocksListTableComponent,
  KpiPlanningAnalyticsListTableComponent,
  KpiPlanningAnalyticsScheduleChartComponent,
  KpiPlanningAnalyticsScheduleChartViewComponent,
  KpiProcessAnalyticsScheduleChartComponent,
  PieChartComponent,
  ProductionGridQualityComponent,
  CustomDateRangeComponent,
  TclassFilterComponent,
  NavigationComponent,
  HeaderFilterComponent,
  CheckBoxComponent,
  PowerForecastChartComponent,
  NotificationMessageComponent,
  KpiAvailabilityDailyChartComponent,
  KpiAvailabilityMonthlyChartComponent,
  TimeRangeSliderComponent,
  ExportChartComponent,
  TimerComponent,
  AvailabilityHeatmapCanvasComponent,
  HeaderUserSettingsComponent,
  TimezoneSwitchComponent,
  NewApplicationVersionPopupComponent,
  LoadFactorChartComponent,
  TachometerComponent,
  BaseMapComponent,
  DoughnutStatusChartComponent,
  GeomapMarkerParkComponent,
  GeomapMarkerStatusComponent,
  PerformanceAnalyzeHighChartComponent,
  PerformanceAlarmListComponent,
  ConfirmationDialogComponent,
  CustomTooltipDirective,
  ProcessDetailsComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        PipesModule,
        DirectivesModule,
        ServicesModule.forRoot(),
        RootSharedModule,
        BsDropdownModule.forRoot(),
        BsDatepickerModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        AccordionModule.forRoot(),
        MatTooltipModule,
        MatMenuModule,
        MatCheckboxModule,
        MatDialogModule,
        MatSelectModule,
        MatExpansionModule,
        MatRadioModule,
        MatTabsModule,
        MatTableModule,
        MatSortModule,
        MatChipsModule,
        FeComponentLibraryModule,
        TranslateModule,
        ThemeModule,
        LibCardModule.forRoot({
            headerHeight: '77',
            sideBarClass: 'side-bar',
            backgroundColor: 'var(--background)',
            interval: 25,
            takeCount: 16,
            mobileHeaderHeight: '65',
            mobileResolution: 600
        }),
        NgbDropdownModule,
        PopoverModule,
        TimepickerModule.forRoot(),
        NgbTooltipModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        NgxSliderModule,
        HighchartsChartModule,
        PortalModule,
        FixedTimeRangeSelectionModule,
    ],
    providers: [ClickedAlarms, LinkingService],
    declarations: COMPONENTS,
    exports: [...COMPONENTS, LibCardModule, ConfirmationDialogComponent, MatTooltipModule]
})
export class SharedModule { }
